module.exports = __webpack_public_path__ + "img/news2.520edca4.jpg";